import { createApp } from "vue";
import App from "./App.vue";
import "./tailwind.css";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import axios from "./plugin/axios";
import VueAxios from "vue-axios";
import "vue-universal-modal/dist/index.css";
import VueUniversalModal from "vue-universal-modal";

createApp(App)
  .use(store)
  .use(router)
  .use(VueAxios, axios)
  .use(VueUniversalModal, {
    teleportTarget: "#modals",
  })
  .mount("#app");
